/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchasesResponseApiModel } from '../../models/purchases-response-api-model';

export interface GetPurchases$Params {

/**
 * response size
 */
  limit?: number;

/**
 * current page
 */
  page?: number;
}

export function getPurchases(http: HttpClient, rootUrl: string, params?: GetPurchases$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchasesResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, getPurchases.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('page', params.page, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchasesResponseApiModel>;
    })
  );
}

getPurchases.PATH = '/marketplace/purchases';
